"use client";
import Image from "next/image";
import {
  InfoIcon,
  calender,
  email,
  location,
  phone,
  whatsapp,
  shareIcon,
  Installments,
} from "../../../public/icons";
import { useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Overlay,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import styles from "../../styles/ProductDetail.module.css";
import SendEmailForm from "../../components/SendEmailForm";
import Link from "next/link";
import useAuth from "../../components/auth/useAuth";
import { useRouter } from "next/navigation";
import ReserveDetails from "../../components/ReserveDetails";
import SignInModal from "../../components/SignInModal";
// import { faCircleInfo, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UpdateListingViews } from "../../app/apis/postApis";
import { useMutation } from "@tanstack/react-query";
import loadStyle from "../../styles/LoadingCard.module.css";
import { useUserStore } from "../../store/User";
import withModalAuth from "../../components/auth/withModalAuth";
import { storeLogo } from "../../../public/images";
import PhoneNumberModal from "../../components/PhoneNumberModal";
import WishlistIcon from "../../components/WishlistIcon";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  faClone as thinclone,
  faCopy,
  faEnvelope,
  faMoneyBill1,
} from "@fortawesome/free-regular-svg-icons";
import {
  faBars,
  faClone,
  faMoneyBill,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import SendEmail from "../ProductListing/SendEmail";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "next-share";
import {
  marketplaceCdn,
  marketplaceUrl,
  marketplaceWeb,
} from "../../utility/env";
import { faArrowRight, faPhone } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Phone_BtnClick,
  Res_btnClick,
  store_visit,
  wa_BtnClick,
} from "../../UserEvents/UserEvents";
import { sendGTMEvent } from "@next/third-parties/google";
import OrderModal from "../../components/OrderModal";
import GuestOrderModal from "../../components/GuestOrderModal";
import OTPModal from "../../components/User/OTPModal";
import {
  trackBuyNow,
  trackContact,
  trackReserve,
  trackStoreVisit,
} from "../../utility/UserEvents";
import { LeadType } from "../../Constants/userEventEnums";
const ProductDetailSection = ({ fetchedData, isLoading }: any) => {
  const { getToken } = useAuth();

  const { user, token } = useUserStore((state: any) => state);
  const [title, setTitle] = useState("");
  const [emailForm, setEmailForm] = useState<boolean>(false);
  const [showWhatsapp, setShowWhatsapp] = useState<boolean>(false);
  const [showNumbers, setShowNumbers] = useState<boolean>(false);
  const [signInModal, setSignInModal] = useState(false);
  const [PNModal, setPNModal] = useState(false);
  const [emailModal, setEmailModal] = useState<any>(false);
  const [reserveModal, setReserveModal] = useState(false);
  const [OverlayShow, setOverlayShow] = useState(false);
  const [copyClipboard, setCopyClipboard] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [guestOrderModal, setGuestOrderModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpVerified, setOTPVerified] = useState(false);
  const shareTarget = useRef(null);

  const noPart = fetchedData?.item?.location?.location_number.split("-");
  const userId = user?.uuid;

  const router = useRouter();
  interface obj {
    fk_listing_id: number;
    fk_user_id?: string;
  }
  const mutation = useMutation({
    mutationFn: UpdateListingViews,
    onSuccess: (data, variables, context) => {},
  });
  useEffect(() => {
    if (fetchedData?.listing_id) {
      const object: obj = {
        fk_listing_id: fetchedData?.listing_id,
        fk_user_id: userId,
      };
      mutation.mutate(object);
    }
  }, [fetchedData]);

  const handleReserveModal = () => {
    if (user?.status === 0) {
      return Swal.fire({
        title: "Verify your account!",
        text: "verify your account to get access",
        icon: "warning",
        showConfirmButton: false,
        timer: 2000,
      });
    }
    setTitle(" To Reserve this item, please create an account.");
    if (user) {
      setReserveModal(true);
    } else {
      setShowOTPModal(true);
      // setSignInModal(true);
    }
  };

  const handleOrderModal = () => {
    if (user) {
      router.push(`/Orders/checkout?product_id=${fetchedData?.listing_id}`);
    } else {
      setGuestOrderModal(true);
    }
  };

  const calculatePrice = (price: any, discount: any, discountUnit: any) => {
    if (discountUnit === "percentage") {
      return price - price * (discount / 100);
    } else if (discountUnit === "fixed") {
      return price - discount;
    }
  };

  const typeObject: {
    [key: string]: string;
  } = {
    Laptop: "laptopListings",
    Mobile: "mobileListings",
    Tablet: "tabletListings",
    "TV / Monitor": "tvMonitorListings",
    "Desktop Computer": "desktopListings",
    Accessories: "accessoryListings",
  };

  const handleClickOutside = (event: any) => {
    if (
      shareTarget.current &&
      !shareTarget.current.contains(event.target) &&
      !event.target.classList.contains("overlay-content")
    ) {
      setOverlayShow(false);
    }
  };
  const copyToClipboard = (links: any) => {
    navigator.clipboard.writeText(links);
    setCopyClipboard(true);
  };
  useEffect(() => {
    // Attach the click event to the document when the component mounts

    if (typeof document !== "undefined") {
      document.addEventListener("click", handleClickOutside);
    }

    // Clean up the event listener when the component unmounts
    return () => {
      if (typeof document !== "undefined") {
        document.removeEventListener("click", handleClickOutside);
      }
    };
  }, []);

  const renderTooltipEmail = (props: any) => (
    <Tooltip id="tooltip" {...props}>
      Send Email
    </Tooltip>
  );
  const renderTooltipWhatsapp = (props: any) => (
    <Tooltip id="tooltipWhatsapp" {...props}>
      Contact on Whatsapp
    </Tooltip>
  );
  const renderTooltipShare = (props: any) => (
    <Tooltip id="tooltipWhatsapp" {...props}>
      Share
    </Tooltip>
  );

  return (
    <>
      {isLoading ? (
        <h1
          style={{ width: "380px", height: "37px" }}
          className={` ${loadStyle.skeleton} fw-bold  fs-16 mb-3`}
        ></h1>
      ) : (
        <h1 className={`mb-1 ${styles.title}`}>
          {fetchedData?.listing_title}{" "}
          {fetchedData?.mobileListings?.is_pta_approved === 0
            ? "(NON PTA)"
            : fetchedData?.mobileListings?.is_pta_approved === 1
              ? "(PTA)"
              : ""}
        </h1>
      )}
      {fetchedData?.activation_date && (
        <div className="d-flex justify-content-end">
          <p className="text-muted fs-12 ">{`Last Updated:  ${moment
            .utc(fetchedData?.activation_date)
            .format("MMM DD, YYYY ")}`}</p>
        </div>
      )}

      {fetchedData?.activation_date === null ||
      fetchedData?.archived_on !== null ||
      fetchedData?.is_deleted === true ||
      fetchedData?.is_deleted === true ||
      fetchedData?.listed_quantity == null ||
      fetchedData?.listed_quantity === 0 ? (
        <>
          {!isLoading ? (
            <Alert variant="danger">
              <Image src={InfoIcon} alt="InfoIcon" height={24} />{" "}
              <span
                className="ps-2 lead fw-lighter"
                style={{ verticalAlign: "middle" }}
              >
                {fetchedData?.status}!
              </span>
            </Alert>
          ) : (
            <div
              style={{ width: "288px", height: "50px" }}
              className={`${loadStyle.skeleton}  `}
            ></div>
          )}
        </>
      ) : (
        ""
      )}

      <div
        className={`d-flex justify-content-between align-items-baseline ${
          fetchedData?.activation_date === null ||
          fetchedData?.archived_on !== null ||
          fetchedData?.is_deleted === true ||
          fetchedData?.is_deleted === true ||
          fetchedData?.listed_quantity == null ||
          fetchedData?.listed_quantity === 0
            ? "- -"
            : ""
        }`}
      >
        <h3 className={`mb-0 align-items-baseline ${styles.price} `}>
          {fetchedData?.activation_date === null ||
          fetchedData?.archived_on !== null ||
          fetchedData?.is_deleted === true ||
          fetchedData?.is_deleted === true ||
          fetchedData?.listed_quantity == null ||
          fetchedData?.listed_quantity === 0 ? (
            "Rs - -"
          ) : fetchedData?.effective_price === 0 ? (
            <div className="d-none  mb-1 ">
              <h3 style={{ fontSize: "19px" }}>Contact Seller For Price</h3>
            </div>
          ) : (
            ` Rs ${calculatePrice(
              fetchedData?.online_price,
              fetchedData?.online_discount,
              fetchedData?.online_discount_unit
            )?.toLocaleString("en-IN")}`
          )}

          {fetchedData?.online_discount > 0 ? (
            <sub
              className={`text-secondary ms-1 text-decoration-line-through ${styles.originalPrice} `}
            >
              {fetchedData?.activation_date === null ||
              fetchedData?.archived_on !== null ||
              fetchedData?.is_deleted === true ||
              fetchedData?.is_deleted === true ||
              fetchedData?.listed_quantity == null ||
              fetchedData?.listed_quantity === 0 ||
              fetchedData?.effective_price === 0
                ? ""
                : ` Rs. ${fetchedData?.online_price}`}
            </sub>
          ) : (
            ""
          )}
        </h3>
        <div
          style={{
            display:
              fetchedData?.activation_date === null ||
              fetchedData?.archived_on !== null ||
              fetchedData?.is_deleted === true ||
              fetchedData?.listed_quantity == null ||
              fetchedData?.effective_price === 0
                ? "none"
                : "",
          }}
        >
          {fetchedData?.online_discount > 0 && (
            <span className={`${styles.discount} text-success `}>
              {" "}
              {fetchedData?.online_discount_unit === "fixed"
                ? "Rs." + fetchedData?.online_discount + ` OFF`
                : fetchedData?.online_discount + `% OFF`}
            </span>
          )}
        </div>
      </div>
      <hr className={`mb-1 ${styles.separator}`} />
      <Row>
        <Col xs="4" sm="4" md="4" lg="3">
          <p className={`mb-0 ${styles.list}`}>Brand:</p>
        </Col>
        <Col xs="8" sm="8" md="8" lg="9">
          <p className={`mb-0 ${styles.list}`}>
            {fetchedData?.[
              typeObject[fetchedData?.item?.["categoriesTable"].label]
            ]?.brand
              ? fetchedData?.[
                  typeObject[fetchedData?.item?.["categoriesTable"].label]
                ]?.brand
              : "- -"}
          </p>
        </Col>

        <Col xs="4" sm="4" md="4" lg="3">
          <p className={`mb-0 ${styles.list}`}>Model:</p>
        </Col>
        <Col xs="8" sm="8" md="8" lg="9">
          <p className={`mb-0 ${styles.list}`}>
            {fetchedData?.[
              typeObject[fetchedData?.item?.["categoriesTable"].label]
            ]?.model
              ? fetchedData?.[
                  typeObject[fetchedData?.item?.["categoriesTable"].label]
                ]?.model
              : "- -"}
          </p>
        </Col>

        {fetchedData?.item?.["categoriesTable"].label === "Mobile" ||
        fetchedData?.item?.["categoriesTable"].label === "Tablet" ? (
          <>
            <Col xs="4" sm="4" md="4" lg="3">
              <p className={`mb-0 ${styles.list}`}>Ram/Storage:</p>
            </Col>
            <Col xs="8" sm="8" md="8" lg="9">
              <p className={`mb-0 ${styles.list}`}>
                {fetchedData?.[
                  typeObject[fetchedData?.item?.["categoriesTable"].label]
                ]?.ram ||
                fetchedData?.[
                  typeObject[fetchedData?.item?.["categoriesTable"].label]
                ]?.storage_mobile
                  ? `${
                      fetchedData?.[
                        typeObject[fetchedData?.item?.["categoriesTable"].label]
                      ]?.ram || "- -"
                    }/${
                      fetchedData?.[
                        typeObject[fetchedData?.item?.["categoriesTable"].label]
                      ]?.storage_mobile + " GB" || "- -"
                    }`
                  : "- -"}
              </p>
            </Col>
          </>
        ) : null}

        {fetchedData?.item?.["categoriesTable"].label === "TV / Monitor" ? (
          <>
            <Col xs="4" sm="4" md="4" lg="3">
              <p className={`mb-0 ${styles.list} text-nowrap`}>Screen Size:</p>
            </Col>
            <Col xs="8" sm="8" md="8" lg="9">
              <p className={`mb-0 ${styles.list}`}>
                {fetchedData?.[
                  typeObject[fetchedData?.item?.["categoriesTable"].label]
                ]?.screen_size
                  ? `${
                      (
                        Number(
                          fetchedData?.[
                            typeObject[
                              fetchedData?.item?.["categoriesTable"].label
                            ]
                          ]?.screen_size
                        ) || 0
                      ).toFixed(0) + '"'
                    }
`
                  : "- -"}
              </p>
            </Col>
          </>
        ) : null}

        <Col xs="4" sm="4" md="4" lg="3">
          <p className={`mb-0 m-0 p-0 ${styles.list}`}> Condition:</p>
        </Col>
        <Col xs="8" sm="8" md="8" lg="7">
          <p className={`mb-0 ${styles.list} `}>
            {fetchedData?.item.condition_item}
          </p>
        </Col>
        <Col xs="4" sm="4" md="4" lg="3">
          <p className={`mb-0 ${styles.list}`}>Availability:</p>
        </Col>

        <Col xs="8" sm="8" md="8" lg="9">
          {isLoading ? (
            <div
              style={{ width: "188px", height: "25px" }}
              className={`${loadStyle.skeleton}  `}
            ></div>
          ) : (
            <>
              {" "}
              <div
                className={`${
                  fetchedData?.activation_date === null ||
                  fetchedData?.archived_on !== null ||
                  fetchedData?.is_deleted === true ||
                  fetchedData?.is_deleted === true ||
                  fetchedData?.listed_quantity == null ||
                  fetchedData?.listed_quantity === 0
                    ? "UnAvailable"
                    : ""
                }`}
              >
                <span className={`mb-0 fw-bold ${styles.availability}`}>
                  {fetchedData?.listed_quantity > 0
                    ? "In Stock"
                    : "Unavailable"}
                </span>{" "}
                <span
                  className={`${styles.quantity} `}
                  style={{
                    display:
                      fetchedData?.activation_date === null ||
                      fetchedData?.archived_on !== null ||
                      fetchedData?.is_deleted === true ||
                      fetchedData?.is_deleted === true ||
                      fetchedData?.listed_quantity == null ||
                      fetchedData?.listed_quantity === 0
                        ? "none"
                        : "",
                  }}
                >
                  (Only {fetchedData?.listed_quantity} left)
                </span>
              </div>
            </>
          )}
        </Col>
        {fetchedData?.item?.["categoriesTable"].label === "Laptop" &&
          fetchedData?.laptopListings.graphic_card_name !== "nil" && (
            <>
              {" "}
              <Col xs="4" sm="4" md="4" lg="3">
                <p className={`mb-0 ${styles.list}`}>GPU:</p>
              </Col>
              <Col xs="8" sm="8" md="8" lg="7">
                <p className={`mb-0 ${styles.list} `}>
                  {fetchedData?.laptopListings.graphic_card_name}
                </p>
              </Col>
            </>
          )}
        {fetchedData?.item?.["categoriesTable"].label === "Laptop" && (
          <>
            {" "}
            <Col xs="4" sm="4" md="4" lg="3">
              <p className={`mb-0 ${styles.list}`}>RAM:</p>
            </Col>
            <Col xs="8" sm="8" md="8" lg="7">
              <p className={`mb-0 ${styles.list} `}>
                {fetchedData?.laptopListings.ram} GB
              </p>
            </Col>
          </>
        )}
        {fetchedData?.item?.["categoriesTable"].label === "Laptop" && (
          <>
            {" "}
            <Col xs="4" sm="4" md="4" lg="3">
              <p className={`mb-0 ${styles.list}`}>Storage:</p>
            </Col>
            <Col xs="8" sm="8" md="8" lg="7">
              <p className={`mb-0 ${styles.list} `}>
                {fetchedData?.laptopListings.storage_ssd > 0 &&
                fetchedData?.laptopListings.storage_hdd > 0
                  ? `${fetchedData?.laptopListings.storage_ssd + " GB SSD" + " + " + fetchedData?.laptopListings.storage_hdd + " GB HDD"}`
                  : fetchedData?.laptopListings.storage_hdd > 0
                    ? fetchedData?.laptopListings.storage_hdd + " GB HDD"
                    : fetchedData?.laptopListings.storage_ssd > 0
                      ? fetchedData?.laptopListings.storage_ssd + "GB SSD"
                      : "--"}
              </p>
            </Col>
          </>
        )}
        {!isLoading && (
          <>
            <Col xs="4" sm="4" md="4" lg="3">
              <p className={`mb-0 text-nowrap m-0 p-0 ${styles.list}`}>
                {" "}
                Delivery ETA:
              </p>
            </Col>
            <Col xs="8" sm="8" md="8" lg="7">
              <p className={`mb-0 ${styles.list} `}> 24 - 48 Hrs</p>
            </Col>
          </>
        )}
      </Row>
      <hr className={`mb-1 ${styles.separator}`} />
      <div className="d-flex gap-3 my-3">
        <p className={`mb-0 ${styles.list}`}>Available colors:</p>
        <p className={`mb-0 ${styles.list}`}>
          {fetchedData?.listingColorAssociations[0]?.color
            ? fetchedData?.listingColorAssociations[0]?.color
            : "- -"}
        </p>
      </div>
      <hr className={`mb-1 ${styles.separator}`} />

      {isLoading ? (
        <h5
          style={{ width: "380px", height: "37px" }}
          className={` ${loadStyle.skeleton} fw-bold  fs-16 mb-3`}
        ></h5>
      ) : (
        <>
          <Row className="pt-1">
            <div className="d-flex my-2 text-center">
              <Image
                className="mt-1"
                src={location}
                alt="location"
                width={15}
                height={15}
              />
              <span className={`ms-1 text-capitalize ${styles.location}`}>
                {fetchedData?.item?.location?.address}
              </span>
            </div>
          </Row>
          <div>
            <div
              className={`mt-3 ${
                fetchedData?.activation_date === null ||
                fetchedData?.archived_on !== null ||
                fetchedData?.is_deleted === true ||
                fetchedData?.is_deleted === true ||
                fetchedData?.listed_quantity == null ||
                fetchedData?.listed_quantity === 0
                  ? "d-none"
                  : "d-flex"
              }`}
            >
              {fetchedData?.item?.location?.city?.is_active_for_delivery &&
              fetchedData?.effective_price > 0 &&
              fetchedData?.item?.shopTable?.shopOption[0]?.is_d4u_enabled ? (
                <Button
                  size="sm"
                  className={`mx-2 ${
                    fetchedData?.item?.location?.city?.is_active_for_delivery &&
                    fetchedData?.effective_price > 0 &&
                    fetchedData?.item?.shopTable?.shopOption[0]?.is_d4u_enabled
                      ? "w-50 d-block"
                      : "w-25 d-none"
                  }  ${styles.reserve_btn} `}
                  variant="outline-primary"
                  onClick={() => {
                    handleOrderModal();
                    
                  }}
                  disabled={
                    fetchedData?.activation_date === null ||
                    fetchedData?.archived_on !== null ||
                    fetchedData?.is_deleted === true ||
                    fetchedData?.is_deleted === true ||
                    fetchedData?.listed_quantity == null ||
                    fetchedData?.listed_quantity === 0
                  }
                >
                  <span className="fs-6">Buy Now </span>
                </Button>
              ) : (
                <Button
                  size="sm"
                  className={`${
                    fetchedData?.effective_price > 0 ? "w-50" : "w-25"
                  }  ${styles.reserve_btn} mx-2 `}
                  variant="primary"
                  onClick={() => {
                    handleReserveModal();

                    trackReserve(
                      fetchedData?.listing_id,
                      fetchedData?.listing_title,
                      user?.uuid,
                      fetchedData?.effective_price,

                      fetchedData.item.shopTable?.shop_id,
                      fetchedData?.item?.shopTable?.username,
                      `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}products/${fetchedData?.listing_title.replaceAll(" ", "-").replaceAll("/", "")}-${fetchedData?.listing_id}`
                    );
                  }}
                  disabled={
                    fetchedData?.activation_date === null ||
                    fetchedData?.archived_on !== null ||
                    fetchedData?.is_deleted === true ||
                    fetchedData?.is_deleted === true ||
                    fetchedData?.listed_quantity == null ||
                    fetchedData?.listed_quantity === 0
                  }
                >
                  <span className="fs-6">Reserve</span>
                </Button>
              )}

              <Button
                className={` mx-2 ${
                  fetchedData?.effective_price > 0 ? "d-none" : ""
                } `}
                variant="outline-primary"
                onClick={() => {
                  trackContact(
                    fetchedData.shop_id,
                    user ? userId : null,
                    LeadType.PHONE,
                    fetchedData?.item?.location?.location_number,

                    `${
                      process.env.NEXT_PUBLIC_MARKETPLACE_URL
                    }products/${fetchedData?.listing_title.replaceAll(
                      " ",
                      "-"
                    )}-${fetchedData?.listing_id}`,
                    // fetchedData?.listing_title,
                    fetchedData?.item.shopTable?.shop_name
                  );

                  window.open(
                    `tel: ${
                      fetchedData?.item.shopTable?.on_payment
                        ? fetchedData?.item?.location?.location_number
                        : "+923104447724".replace("+92", 92).replaceAll("-", "")
                    }`,
                    "_self"
                  );
                }}
              >
                Call for Price
              </Button>
              <OverlayTrigger
                placement="top"
                overlay={OverlayShow ? <></> : renderTooltipShare}
              >
                <Col
                  xs="2"
                  xl="1"
                  lg="1"
                  md="2"
                  sm="2"
                  ref={shareTarget}
                  onClick={() => {
                    setOverlayShow(!OverlayShow);
                  }}
                  className={`d-flex align-items-center cursor-pointer px-4 justify-content-center  rounded-1 ${styles.actionBtns}`}
                >
                  <Image src={shareIcon} alt="share" width={35} height={30} />
                </Col>
              </OverlayTrigger>
              <Overlay
                target={shareTarget.current}
                show={OverlayShow}
                placement="top"
              >
                {(props) => (
                  <Tooltip id="overlay-example" className="" {...props}>
                    <div className="d-flex align-items-center">
                      <FacebookShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        quote={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                        hashtag={"#TechTalk #techBazzar"}
                      >
                        <FacebookIcon className="mx-2" size={32} round />
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        title={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                      >
                        <TwitterIcon className="mx-2" size={32} round />
                      </TwitterShareButton>
                      <WhatsappShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        title={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                        separator=":: "
                      >
                        <WhatsappIcon className="mx-2" size={32} round />
                      </WhatsappShareButton>
                      <div className="w-100 bg-light p-1 rounded-circle">
                        <FontAwesomeIcon
                          onClick={() => {
                            copyToClipboard(
                              encodeURI(
                                `${marketplaceWeb}/products/${fetchedData.listing_title
                                  .replaceAll(" ", "-")
                                  .replaceAll(
                                    "/",
                                    "--"
                                  )}-${fetchedData.listing_id}`
                              )
                            );
                          }}
                          icon={copyClipboard ? faClone : thinclone}
                          className=" cursor-pointer p-1 "
                          fontSize={22}
                        />
                      </div>
                    </div>
                  </Tooltip>
                )}
              </Overlay>
              <div
                className={` ms-0 rounded-2 pb-1 justify-content-center d-flex align-items-center ${styles.wishlist}`}
              >
                <div className="ms-2   ">
                  <WishlistIcon
                    page="pdp"
                    listingId={fetchedData?.listing_id}
                    title={fetchedData?.listing_title}
                  />
                </div>
              </div>
            </div>

            <Link
              className={` my-2 mx-2  ${fetchedData?.item?.location?.city?.city_name === "Lahore" && fetchedData?.effective_price >= 20000 && fetchedData?.item.condition_item === "New" ? "d-flex" : "d-none"}
                ${
                  fetchedData?.activation_date === null ||
                  fetchedData?.archived_on !== null ||
                  fetchedData?.is_deleted === true ||
                  fetchedData?.is_deleted === true ||
                  fetchedData?.listed_quantity == null ||
                  fetchedData?.listed_quantity === 0
                    ? styles.blur
                    : ""
                }
                  `}
              href={
                "https://docs.google.com/forms/d/e/1FAIpQLScLMN6ysETI8FWGU3S648okXlIbll_wTadWnYo-TMZi3E_JPg/viewform?embedded=true"
              }
              target="_blank"
            >
              <span
                className={`  d-flex align-items-center pe-2  text-muted     ${
                  fetchedData?.effective_price > 0 ? "w-50" : "w-25"
                }  ${styles.installments_link} fw-500  cursor-pointer`}
                // variant="outline-primary"
              >
                Apply for Installments
              </span>
              <Image
                className="d-flex"
                src={Installments}
                alt={"installments"}
                height={28}
                width={28}
              />
            </Link>
          </div>
        </>
      )}
      <div
        className={`  d-none d-md-flex    ${
          fetchedData?.activation_date === null ||
          fetchedData?.archived_on !== null ||
          fetchedData?.is_deleted === true ||
          fetchedData?.is_deleted === true ||
          fetchedData?.listed_quantity == null ||
          fetchedData?.listed_quantity === 0
            ? styles.blur
            : ""
        }`}
        style={{
          display:
            fetchedData?.activation_date === null ||
            fetchedData?.archived_on !== null ||
            fetchedData?.is_deleted === true ||
            fetchedData?.is_deleted === true ||
            fetchedData?.listed_quantity == null ||
            fetchedData?.listed_quantity === 0
              ? "none"
              : "",
        }}
      >
        {otpVerified || (user && user.is_phone_number_verified) ? (
          <Row className="d-flex " style={{ gap: "8px" }}>
            <Col
              xs="5"
              xl="6"
              lg="6"
              md="5"
              sm="5"
              className={`d-flex align-items-center justify-content-center  px-0 mt-4 mb-2 ms-1 rounded-1 cursor-pointer ${styles.actionBtns}`}
            >
              <FontAwesomeIcon
                className={`${styles.whatsappIcon} me-2`}
                fontSize={16}
                icon={faPhone}
              />{" "}
              {showNumbers === true ? (
                <a
                  className="fs-14 fw-bold"
                  href={`tel: ${fetchedData?.item?.location?.location_number}`}
                  target="_self"
                  onClick={() => {
                    trackContact(
                      fetchedData.shop_id,
                      user ? userId : null,
                      LeadType.PHONE,
                      fetchedData?.item?.location?.location_number,

                      `${
                        process.env.NEXT_PUBLIC_MARKETPLACE_URL
                      }products/${fetchedData?.listing_title.replaceAll(
                        " ",
                        "-"
                      )}-${fetchedData?.listing_id}`,
                      // fetchedData?.listing_title,
                      fetchedData?.item.shopTable?.shop_name
                    );
                  }}
                >
                  {fetchedData?.item.shopTable?.on_payment ||
                  fetchedData?.item?.location?.city?.city_name === "Karachi"
                    ? fetchedData?.item?.location?.location_number
                    : "+923104447724"}
                </a>
              ) : (
                <span
                  onClick={() => {
                    trackContact(
                      fetchedData.shop_id,
                      user ? userId : null,
                      LeadType.PHONE,
                      fetchedData?.item?.location?.location_number,

                      `${
                        process.env.NEXT_PUBLIC_MARKETPLACE_URL
                      }products/${fetchedData?.listing_title.replaceAll(
                        " ",
                        "-"
                      )}-${fetchedData?.listing_id}`,
                      // fetchedData?.listing_title,
                      fetchedData?.item.shopTable?.shop_name
                    );

                    if (user) {
                      setShowNumbers(true);
                      window.open(
                        `tel: ${fetchedData?.item.shopTable?.on_payment || fetchedData?.item?.location?.city?.city_name === "Karachi" ? fetchedData?.item?.location?.location_number : "+923104447724"}`,
                        "_self"
                      );
                    } else {
                      // setSignInModal(true);
                    }
                  }}
                  className={`fs-14 link`}
                >
                  Show Phone No.
                </span>
              )}
            </Col>
            <OverlayTrigger placement="top" overlay={renderTooltipWhatsapp}>
              <Col
                xs="2"
                xl="2"
                lg="2"
                md="2"
                sm="2"
                onClick={() => {
                  trackContact(
                    fetchedData.item.shopTable.shop_id,
                    user ? userId : null,
                    LeadType.WHATSAPP,
                    fetchedData?.item?.location?.location_number,
                    `${
                      process.env.NEXT_PUBLIC_MARKETPLACE_URL
                    }products/${fetchedData?.listing_title
                      .replaceAll(" ", "-")
                      .replaceAll("/", "")}-${fetchedData?.listing_id}`,
                    fetchedData?.item.shopTable?.shop_name
                  );

                  if (user) {
                    window.open(
                      `https://wa.me/${
                        fetchedData?.item.shopTable?.on_payment ||
                        fetchedData?.item?.location?.city?.city_name ===
                          "Karachi"
                          ? fetchedData?.item?.location?.location_number
                              .replace("+92", 92)
                              .replaceAll("-", "")
                          : "+923104447724"
                              .replace("+92", 92)
                              .replaceAll("-", "")
                      }?text=Hello, I am interested in your item ${
                        fetchedData?.url
                      } `
                    );
                  } else {
                  }
                }}
                className={`d-flex align-items-center justify-content-center  px-4  mt-4 mb-2 rounded-1 cursor-pointer ${styles.actionBtns}`}
              >
                <Image
                  className="mt-1"
                  src={whatsapp}
                  alt="whatsapp"
                  width={30}
                  height={30}
                />
              </Col>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={renderTooltipEmail}>
              <Col
                xs="2"
                xl="1"
                lg="1"
                md="2"
                sm="2"
                onClick={() => {
                  // sendGTMEvent({
                  //   event: `Interested-Email`,
                  //   value: fetchedData.item.shopTable.shop_id,
                  //   action: "cilck",
                  //   location: "PDP",
                  //   ListingId: fetchedData?.listing_id,
                  //   shopId: fetchedData.item.shopTable.shop_id,
                  // });
                  setEmailModal(true);
                }}
                className={`d-flex align-items-center py-md-3 py-sm-3 py-3 px-4 justify-content-center   mt-4 mb-2 rounded-1 cursor-pointer ${styles.actionBtns}`}
              >
                <FontAwesomeIcon
                  className={`${styles.emailIcon} `}
                  fontSize={20}
                  icon={faEnvelope}
                />
              </Col>
            </OverlayTrigger>
          </Row>
        ) : (
          <>
            <Col
              md={6}
              className="d-flex m-2 w-100 d-none d-md-flex"
              style={{ gap: "5px" }}
            >
              <Button
                className={`w-50  ${styles.reserve_btn}    text-nowrap   btn-lg`}
                onClick={() => setShowOTPModal(true)}
                variant="secondary"
              >
                Contact Seller
              </Button>

              {/* <OverlayTrigger
                placement="top"
                overlay={OverlayShow ? <></> : renderTooltipShare}
              >
                <Col
                  xs="2"
                  xl="1"
                  lg="1"
                  md="2"
                  sm="2"
                  ref={shareTarget}
                  onClick={() => {
                    setOverlayShow(!OverlayShow);

                  }}
                  className={`d-flex align-items-center cursor-pointer px-4 justify-content-center  rounded-1 ${styles.actionBtns}`}
                >
                  <Image src={shareIcon} alt="share" width={35} height={30} />
                </Col>
              </OverlayTrigger>
              <Overlay
                target={shareTarget.current}
                show={OverlayShow}
                placement="top"
              >
                {(props) => (
                  <Tooltip id="overlay-example" className="" {...props}>
                    <div className="d-flex align-items-center">
                      <FacebookShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        quote={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                        hashtag={"#TechTalk #techBazzar"}
                      >
                        <FacebookIcon className="mx-2" size={32} round />
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        title={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                      >
                        <TwitterIcon className="mx-2" size={32} round />
                      </TwitterShareButton>
                      <WhatsappShareButton
                        url={encodeURI(
                          `${marketplaceWeb}/products/${fetchedData.listing_title
                            .replaceAll(" ", "-")
                            .replaceAll("/", "--")}-${fetchedData.listing_id}`
                        )}
                        title={
                          "Our primary mission is to digitally transform the retail tech industry by bridging the gap between tech retailers and potential customers."
                        }
                        separator=":: "
                      >
                        <WhatsappIcon className="mx-2" size={32} round />
                      </WhatsappShareButton>
                      <div className="w-100 bg-light p-1 rounded-circle">
                        <FontAwesomeIcon
                          onClick={() => {
                            copyToClipboard(
                              encodeURI(
                                `${marketplaceWeb}/products/${fetchedData.listing_title
                                  .replaceAll(" ", "-")
                                  .replaceAll(
                                    "/",
                                    "--"
                                  )}-${fetchedData.listing_id}`
                              )
                            );
                          }}
                          icon={copyClipboard ? faClone : thinclone}
                          className=" cursor-pointer p-1 "
                          fontSize={22}
                        />
                      </div>
                    </div>
                  </Tooltip>
                )}
              </Overlay> */}
            </Col>
          </>
        )}

        {isLoading ? (
          <h5
            style={{ width: "380px", height: "37px" }}
            className={` ${loadStyle.skeleton} fw-bold  fs-16 mb-3`}
          ></h5>
        ) : (
          <></>
        )}
      </div>
      <div className={`mt-2`}>
        <Row className={styles.infoSection}>
          <Col xs="1" sm="2" md="2" lg="2" xl="2" className={`${styles.logo}`}>
            <Image
              src={
                fetchedData?.item.shopTable?.logo_path === null
                  ? storeLogo
                  : `${marketplaceCdn}/${fetchedData?.item.shopTable?.logo_path}`
              }
              className={styles.shopLogo}
              alt="Logo"
              width={68}
              height={68}
            />
          </Col>

          <Col xs="5" sm="4" md="4" lg="4" xl="5">
            <h5 className="m-0 fw-bold fs-18">
              {fetchedData?.item.shopTable?.shop_name}
            </h5>
            <div className="d-flex align-items-center ">
              <Image src={location} alt="location" width={15} height={15} />
              <span className="ms-1">
                {fetchedData?.item.location?.location_nick}
              </span>
            </div>
            {/* <span className="ms-3 fs-14 text-center d-flex">
              ({fetchedData?.item.location?.address})
            </span> */}
          </Col>
          <Col
            xs="4"
            sm="5"
            md="5"
            lg="4"
            xl="4"
            className="px-0 text-center mt-2 mt-md-0 mt-lg-0"
          >
            <Link
              className="d-flex align-items-center justify-content-end gap-1 "
              href={`/store/${fetchedData?.item.shopTable?.username}`}
              onClick={() => {
                trackStoreVisit(
                  fetchedData?.item.shopTable?.shop_id,
                  user?.uuid,
                  "PDP",
                  fetchedData?.item.shopTable?.shop_name,
                  `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}store/${fetchedData?.item.shopTable?.username}`
                );
              }}
            >
              <span className="link "> Visit seller</span>
              <FontAwesomeIcon color="#d957f9" icon={faArrowRight} />
            </Link>
          </Col>
        </Row>
      </div>

      <ReserveDetails
        show={reserveModal}
        setShow={setReserveModal}
        onHide={() => setReserveModal(false)}
        reserveData={{
          shop_id: fetchedData?.item?.shopTable?.shop_id,
          locationId: fetchedData?.item?.location_id,
          listingId: fetchedData?.listing_id,
          itemId: fetchedData?.fk_item_id,
          listedQuantity: fetchedData?.listed_quantity,
          url: `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}products/${fetchedData?.listing_title?.replaceAll(" ", "-")?.replaceAll("/", "--")}-${fetchedData?.listing_id}`,
        }}
      />
      <SignInModal
        title={title}
        show={signInModal}
        onHide={() => setSignInModal(false)}
      />

      <PhoneNumberModal show={PNModal} onHide={() => setPNModal(false)} />
      <OrderModal
        show={orderModal}
        onHide={() => setOrderModal(false)}
        data={fetchedData}
      />
      <SendEmail
        shopData={fetchedData}
        show={emailModal}
        onHide={() => setEmailModal(false)}
      />

      {/* Guest Order */}
      <GuestOrderModal
        show={guestOrderModal}
        onHide={() => setGuestOrderModal(false)}
        setSignIn={setSignInModal}
        setOrderModal={setOrderModal}
        data={fetchedData}

        // data={fetchedData}
      />
      <OTPModal
        show={showOTPModal}
        onHide={() => setShowOTPModal(false)}
        setOTPVerified={setOTPVerified}
        otpVerified={otpVerified}
        shop_name={fetchedData?.item.shopTable?.shop_name}
      />
    </>
  );
};

export default ProductDetailSection;
